<template>
  <van-popup
    :show="show"
    position="bottom"
    :style="{ height: '80%' }"
    round
    @update:show="handleShowChange"
  >
    <div class="picker-header">
      <span class="picker-title">选择课程</span>
      <van-icon name="cross" size="20" @click="close" />
    </div>
    <van-search
      v-model="keyword"
      placeholder="搜索课程名称"
      shape="round"
      @search="loadList(true)"
      @clear="loadList(true)"
    />
    <div class="picker-list">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadList"
      >
        <van-cell
          v-for="item in list"
          :key="item.courseId"
          :title="item.courseName"
          is-link
          @click="handleSelect(item)"
        >
          <template #label>
            <div class="course-meta">
              <van-tag plain type="primary" size="medium">{{ item.subjectName || selectDictLabel(course_subject, item.subject) }}</van-tag>
              <van-tag plain size="medium">{{ item.gradeName || selectDictLabel(grade_list, item.grade) }}</van-tag>
              <span class="course-price">¥{{ item.totalPrice }}/{{ item.classHourCount }}课时</span>
            </div>
          </template>
        </van-cell>
        <van-empty v-if="!loading && list.length === 0" description="暂无课程数据" />
      </van-list>
    </div>
  </van-popup>
</template>

<script setup>
import { ref, watch } from 'vue'
import { listCourse } from '@/api/course'
import { useDict, selectDictLabel } from '@/utils/dict'

const { course_subject, grade_list } = useDict('course_subject', 'grade_list')

const props = defineProps({
  show: { type: Boolean, default: false }
})
const emit = defineEmits(['update:show', 'select'])

const keyword = ref('')
const list = ref([])
const loading = ref(false)
const finished = ref(false)
const pageNum = ref(1)
const pageSize = 20

watch(() => props.show, (val) => {
  if (val) {
    keyword.value = ''
    list.value = []
    pageNum.value = 1
    finished.value = false
    loadList(true)
  }
})

function handleShowChange(val) {
  emit('update:show', val)
}

function close() {
  emit('update:show', false)
}

async function loadList(reset = false) {
  if (reset) {
    pageNum.value = 1
    list.value = []
    finished.value = false
  }
  loading.value = true
  try {
    const res = await listCourse({
      pageNum: pageNum.value,
      pageSize: pageSize,
      courseName: keyword.value || undefined
    })
    const rows = res?.rows || res || []
    list.value = reset ? rows : [...list.value, ...rows]
    if (rows.length < pageSize) {
      finished.value = true
    } else {
      pageNum.value++
    }
  } catch (e) {
    finished.value = true
  } finally {
    loading.value = false
  }
}

function handleSelect(item) {
  emit('select', item)
}
</script>

<style scoped>
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebedf0;
}
.picker-title {
  font-size: 16px;
  font-weight: 600;
}
.picker-list {
  height: calc(100% - 100px);
  overflow-y: auto;
}
.course-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.course-price {
  font-size: 12px;
  color: #f56c6c;
}
</style>
